import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';

/**
 * Pyramid
 */
export class Pyramid extends Component { // eslint-disable-line react/prefer-stateless-function
  constructor(props){
    super(props);
    this.state = {
      pyramid: Array(20).fill(0)
    }
  }
  componentDidMount(){
    const { data } = this.props;
    const { pyramid } = this.state;
    if (data) {
      let splits = data.split(',');
      let newPyramid = pyramid;
      splits.map((split,i) => {
        newPyramid[i] = split;
        return null;
      })
      this.setState({
        pyramid: newPyramid
      })
    }

  }
  handlePyramid = setIndex => e => {
    let newPyramid = this.state.pyramid;
    const { value } = e.target;
    if (/[^0-9]/g.test(value)) {
      newPyramid[setIndex] = newPyramid[setIndex];
    } else {
      newPyramid[setIndex] = value;
    }
    this.setState({
      ...this.state,
      pyramid: newPyramid
    },() => {
      const filtered = newPyramid.filter(val => val ? true: false);
      this.props.changeField(filtered.toString())
    });

  }
  render() {
    const { pyramid } = this.state;
    let setNums = Array.from(Array(this.props.sets).keys());
    return setNums.map(setIndex => (
      <TextField
        style={{ width: 60, marginRight: 10, display: 'inline-block' }}
        key={setIndex}
        label={`Set ${setIndex + 1}`}
        value={pyramid[setIndex]}
        onChange={this.handlePyramid(setIndex)}
        margin="dense"
        variant="outlined"
        type="text"
        inputProps={{ maxLength: 5 }}
      />
    ))
  }
}


export default Pyramid;



// WEBPACK FOOTER //
// ./src/components/workouts/inputs/Pyramid.js